import { render, staticRenderFns } from "./empregatransportelogin.vue?vue&type=template&id=bb2807ca&"
import script from "./empregatransportelogin.vue?vue&type=script&lang=js&"
export * from "./empregatransportelogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports